<template>
  <hic-dialog :title="title" :visible="visible" @open="openEditor" @close="cancel" :close-on-click-modal="false" width="60rem">
    <el-form :model="value" :rules="comRules" ref="editor" label-width="5rem" style="padding-right: 3rem">
      <el-row>
        <el-col :span="12">
          <el-form-item label="分类" prop="category">
            <hic-dict-selector style="width: 100%" v-model="value.category" dict-type="MrApiCategory" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="返回值" prop="resultType">
            <hic-dict-selector style="width: 100%" v-model="value.resultType" isEnum dict-type="MrApiResultType" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="名称" prop="name">
            <el-input class="default-input" size="small" type="text" placeholder="请输入" v-model="value.name" :disabled="value.disabled" @change="genCode" v-hic-focus v-hic-select> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="编码" prop="code" key="id">
            <el-input class="default-input" size="small" type="text" placeholder="请输入" v-model="value.code" :disabled="!!value.id"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="value.resultType != Enum.MrApiResultType.值">
          <el-form-item label="排序" prop="struct">
            <el-input class="default-input" size="small" type="text" placeholder="请输入" v-model="value.seqNo" :disabled="value.disabled"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="value.resultType != Enum.MrApiResultType.值">
          <el-form-item label="依赖" prop="struct">
            <el-input class="default-input" size="small" type="text" placeholder="请输入" v-model="value.dependency" :disabled="value.disabled"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="接口路径" prop="path">
            <el-input class="default-input" size="small" type="text" placeholder="请输入" v-model="value.path" :disabled="value.disabled"> </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24" v-if="value.resultType != Enum.MrApiResultType.值">
          <el-form-item label="对象结构" prop="struct">
            <el-tabs type="border-card">
              <el-tab-pane label="编辑">
                <el-input class="default-input" size="small" type="textarea" placeholder="请输入" :rows="8" v-model="value.struct" :disabled="value.disabled"> </el-input>
              </el-tab-pane>
              <el-tab-pane label="预览">
                <el-tree :data="structView" :props="{ label: 'text', children: 'child' }" default-expand-all :empty-text="viewHint">
                  <small slot-scope="{ node, data }">
                    <i :class="utils.eleIcon(data)" />
                    {{ node.label }}
                  </small>
                </el-tree>
              </el-tab-pane>
            </el-tabs>
            <span class="danger">最外层 code 与 text, 不能与其他元数据的最外层 code 与 text 重复！</span>
            <el-input v-model="testUrl" placeholder="请输入测试地址" style="margin-top: 10px" size="small" clearable>
              <el-button slot="append" type="danger" size="mini" @click="test" plain>测试</el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="cancel">关 闭</el-button>
      <el-button v-if="!value.id" type="primary" @click="saveAndNext" :disabled="disabledSaveAndNext">保存并继续新建</el-button>
      <el-button type="primary" @click="save" :disabled="isSaving">确 定</el-button>
    </div>
  </hic-dialog>
</template>

<script>
  import { pinyin as py } from "sw-hic-masterdata";
  import editorUtls from "@/common/editorUtils";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      value: {},
      visible: { type: Boolean, default: false },
    },
    data() {
      return {
        loading: false,
        comRules: {},
        autoNext: false,
        disabledSaveAndNext: false,
        isSaving: false,
        extra: "门诊",
        utils: editorUtls,
        structView: [],
        viewHint: "暂无预览效果，请编辑数据后查看",
        testUrl: "",
      };
    },
    computed: {
      ...mapGetters(["dict", "Enum"]),
      title() {
        if (!this.value.id) {
          return "元数据新建";
        }
        return "元数据编辑";
      },
    },
    watch: {
      "value.struct"(newVal) {
        this.structView = [];

        if (!newVal) {
          this.viewHint = "暂无预览效果，请编辑数据后查看";
          return;
        }
        try {
          var data = JSON.parse(this.value.struct);
        } catch (error) {
          this.viewHint = error.message;
          return;
        }
        Array.isArray(data) ? (this.structView = data) : this.structView.push(data);

        this.recursion(this.structView);
      },
    },
    methods: {
      recursion(arr) {
        arr.forEach((ele) => {
          ele.child = [];

          switch (ele.type) {
            case "obj":
              ele.child = ele.props;
              delete ele.props;
              break;
            case "list":
              ele.child.push(ele.item);
              delete ele.item;
              break;
            default:
              break;
          }

          this.recursion(ele.child);
        });
      },

      openEditor() {
        this.disabledSaveAndNext = false;
        this.isSaving = false;
        this.testUrl = this.value.path;
      },
      save() {
        let _this = this;
        this.$refs.editor
          .validate()
          .then((valid) => {
            console.log(valid);
            _this.disabledSaveAndNext = true;
            _this.isSaving = true;
            return this.$api.Api.save(_this.value);
          })
          .then((res) => {
            _this.$message.success("保存成功！");
            _this.$emit("ok", _this.value);
            if (_this.autoNext) {
              _this.autoNext = false;
              // _this.value = {
              //  type: _this.value.type,
              //  parentType: _this.value.parentType,
              // };
              _this.value.category = null;
              _this.value.path = null;
              _this.value.name = null;
              _this.value.code = null;
              _this.value.seqNo = null;
              _this.value.struct = null;
              _this.value.dependency = null;
              _this.value.resultType = null;
              console.log(_this.value.category);
            } else {
              _this.cancel();
            }
            _this.disabledSaveAndNext = false;
            _this.isSaving = false;
          })
          .catch((err) => {
            if (err) {
              _this.$message.error(err.message || err);
            }
            _this.disabledSaveAndNext = false;
            _this.isSaving = false;
          });
      },
      saveAndNext() {
        this.autoNext = true;
        this.save();
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      genCode(chns) {
        if (!this.value.id) {
          this.$set(this.value, "code", py.chnToPinYin(chns));
          this.$set(this.value, "shortCode", py.getFirstLetter(this.value.code));
        }
      },
      test() {
        this.$api.Api.exec(this.testUrl)
          .then((res) => {
            console.log("原始数据", res);
            let struct = JSON.parse(this.value.struct);
            let result = {};
            let props = struct.props
            if (struct.type === "list") {
              res = res.items[0];
              props = struct.item.props;
            }
            props.forEach((item) => {
              result[item.text] = res[item.code] || "";
            });
            console.log("结果数据", result);
            this.$message.success("执行成功！");
          })
          .catch((err) => {
            this.$message.error("执行失败！");
            console.log(err);
          });
      },
    },
  };
</script>
